/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_No_UsageInputs */

const en_settings_no_usage = /** @type {(inputs: Settings_No_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No AI usage yet. Your credit transactions will appear here.`)
};

const de_settings_no_usage = /** @type {(inputs: Settings_No_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine KI-Nutzung. Deine Aktionshistorie wird hier angezeigt.`)
};

const fr_settings_no_usage = /** @type {(inputs: Settings_No_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune utilisation d'IA pour le moment. Ton historique d'actions apparaîtra ici.`)
};

const es_settings_no_usage = /** @type {(inputs: Settings_No_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay uso de IA. Su historial de acciones aparecerá aquí.`)
};

const it_settings_no_usage = /** @type {(inputs: Settings_No_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun utilizzo AI ancora. Le tue transazioni di credito appariranno qui.`)
};

const nl_settings_no_usage = /** @type {(inputs: Settings_No_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen AI-gebruik. Je credittransacties verschijnen hier.`)
};

const pl_settings_no_usage = /** @type {(inputs: Settings_No_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak użycia AI. Twoje transakcje kredytowe pojawią się tutaj.`)
};

const fi_settings_no_usage = /** @type {(inputs: Settings_No_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä AI-käyttöä. Luottokauppasi näkyvät täällä.`)
};

const da_settings_no_usage = /** @type {(inputs: Settings_No_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen AI-brug endnu. Dine kredittransaktioner vil dukke op her.`)
};

const sv_settings_no_usage = /** @type {(inputs: Settings_No_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen AI-användning ännu. Dina kredittransaktioner kommer att visas här.`)
};

/**
* | output |
* | --- |
* | "No AI usage yet. Your credit transactions will appear here." |
*
* @param {Settings_No_UsageInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_no_usage = /** @type {((inputs?: Settings_No_UsageInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_No_UsageInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_no_usage(inputs)
	if (locale === "fr") return fr_settings_no_usage(inputs)
	if (locale === "es") return es_settings_no_usage(inputs)
	if (locale === "it") return it_settings_no_usage(inputs)
	if (locale === "nl") return nl_settings_no_usage(inputs)
	if (locale === "pl") return pl_settings_no_usage(inputs)
	if (locale === "fi") return fi_settings_no_usage(inputs)
	if (locale === "da") return da_settings_no_usage(inputs)
	if (locale === "sv") return sv_settings_no_usage(inputs)
	return en_settings_no_usage(inputs)
});